import Button from '../../../../components/Button';
import { useGiftForm, handleKeyboardNext, handleKeyboardDone } from '../../../../components/GiftFormContext';
import TextInput, { ErrorMessage } from '../../../../components/Inputs/Text';
import AddressAutocomplete from '../../../../components/Inputs/AddressAutocomplete';
import { useEffect, useState, useRef } from 'react';
import {
  EVENT_GIFT_FLOW_SHIPPING_ADDRESS_CHANGED,
  EVENT_GIFT_FLOW_SHIPPING_DETAILS_COMPLETED,
  EVENT_GIFT_FLOW_SHIPPING_RECIPIENT_NAME_CHANGED,
  sendEvent,
} from '../../../../common/analytics';

const ShippingAddress = ({
  onContinue,
  buttonLabel = 'Continue',
  isModal,
  currentStep,
}) => {
  const {
    recipientName,
    setValue,
    addressLine1,
    addressLine2,
    city,
    state,
    postalCode,
    country,
    delivery,
    showFreeGift,
  } = useGiftForm();

  const [addressValue, setAddressValue] = useState('');

  // Refs for keyboard navigation
  const recipientNameRef = useRef(null);
  const addressRef = useRef(null);

  // Auto-advance if delivery is not 'mail'
  useEffect(() => {
    if (delivery !== 'mail' && onContinue) {
      onContinue();
    }
  }, [delivery, onContinue]);

  const handleAddressChange = (e) => {
    const value = e.target.value;
    setAddressValue(value);
    sendEvent(EVENT_GIFT_FLOW_SHIPPING_ADDRESS_CHANGED, {
      address: value,
      is_free_gift: showFreeGift,
    });
  };

  const validForm =
    recipientName &&
    addressLine1 &&
    city &&
    state &&
    postalCode &&
    country &&
    (country === 'United States' || country === 'Puerto Rico');

  // Check if address is complete (all required fields filled)
  const isAddressComplete = addressLine1 && city && state && postalCode && country;

  const handleContinue = () => {
    sendEvent(EVENT_GIFT_FLOW_SHIPPING_DETAILS_COMPLETED, {
      is_free_gift: showFreeGift,
    });
    onContinue();
  };

  return (
    <>
      <TextInput
        ref={recipientNameRef}
        label='Recipient Name'
        value={recipientName || ''}
        onChange={(e) => {
          setValue('recipientName', e.target.value);
          sendEvent(EVENT_GIFT_FLOW_SHIPPING_RECIPIENT_NAME_CHANGED, {
            recipientName: e.target.value,
            is_free_gift: showFreeGift,
          });
        }}
        enterkeyhint='next'
        onKeyDown={(e) => handleKeyboardNext(e, addressRef)}
      />
      <AddressAutocomplete
        ref={addressRef}
        label='Shipping Address'
        placeholder='Start typing an address...'
        value={addressValue}
        onChange={handleAddressChange}
        addressLine1={addressLine1}
        addressLine2={addressLine2}
        city={city}
        state={state}
        postalCode={postalCode}
        country={country}
        setAddressLine1={(value) => setValue('addressLine1', value)}
        setAddressLine2={(value) => setValue('addressLine2', value)}
        setFormattedAddress={(value) => setValue('formattedAddress', value)}
        setCity={(value) => setValue('city', value)}
        setState={(value) => setValue('state', value)}
        setPostalCode={(value) => setValue('postalCode', value)}
        setCountry={(value) => setValue('country', value)}
        enterkeyhint={isAddressComplete ? 'done' : 'next'}
        onKeyDown={(e) => {
          if (isAddressComplete) {
            handleKeyboardDone(e, addressRef, {
              onProceed: handleContinue,
              isValidForm: validForm,
            });
          }
        }}
      />
      {country && country !== 'United States' && country !== 'Puerto Rico' && (
        <ErrorMessage>
          We currently only support shipping to the United States.
        </ErrorMessage>
      )}
      <Button
        fullWidth
        clickAnimation="bouncy"
        onClick={handleContinue}
        disabled={!validForm}
      >
        {buttonLabel}
      </Button>
    </>
  );
};

export default ShippingAddress;
